<ul class="list-group list-group-flush">
    <ng-template ngFor let-entity [ngForOf]="entities" let-i="index">
        <label for="itemTipo_{{indexUnidadeNegocio}}_{{indexMercado}}_{{indexNaturezaVenda}}_{{i}}" class="col-form-label">
            Tipo de Produto
        </label>
        <li class="list-group-item select">
            <div class="input-group">
                <div class="input-group-prepend delete" *ngIf="canEdit"> 
                    <button type="button" class="btn btn-light btn-delete" (click)="delete(i)">
                        <i class="far fa-trash-alt" aria-hidden="true"></i>
                    </button>
                </div>
                <select class="form-control" name="itemTipo_{{indexUnidadeNegocio}}_{{indexMercado}}_{{indexNaturezaVenda}}_{i}}" id="itemTipo_{{indexUnidadeNegocio}}_{{indexMercado}}_{{indexNaturezaVenda}}_{{i}}" 
                    [ngModel]="entity.idItemTipo || ''" (ngModelChange)="onSelectItemTipo(entity, $event)"
                    #itemTipo="ngModel" [disabled]="!canEdit">
                    <option value="">NÃO INFORMADO</option>
                    <option *ngFor="let itemTipo of itensTipos" [ngValue]="itemTipo.id">{{itemTipo.nome}}</option>
                </select>                          
            </div>       
        </li>
    </ng-template>
    <li class="list-group-item no-entities" *ngIf="!entities || entities.length === 0">
        Nenhum Tipo de Produto Adicionado
    </li>
    <li class="list-group-item options" *ngIf="canEdit">
        <button type="button" class="btn btn-primary btn-add" (click)="insert()">
            <i class="fas fa-plus" aria-hidden="true"></i> Adicionar Tipo de Produto
        </button>
    </li>
</ul>